import React from 'react';

const TotalOrders = () => {
    return (
        <svg width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 15.9C0 10.3938 0 7.64071 1.05455 5.53021C2.02249 3.59308 3.59308 2.02249 5.53021 1.05455C7.64071 0 10.3938 0 15.9 0H24.1C29.6062 0 32.3593 0 34.4698 1.05455C36.4069 2.02249 37.9775 3.59308 38.9454 5.53021C40 7.64071 40 10.3938 40 15.9V24.1C40 29.6062 40 32.3593 38.9454 34.4698C37.9775 36.4069 36.4069 37.9775 34.4698 38.9454C32.3593 40 29.6062 40 24.1 40H15.9C10.3938 40 7.64071 40 5.53021 38.9454C3.59308 37.9775 2.02249 36.4069 1.05455 34.4698C0 32.3593 0 29.6062 0 24.1V15.9Z"
                fill="#D9E4FB"
            />
            <path
                d="M23.4885 24.1735H16.5566"
                stroke="#4E7CFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.9319 20.4889H17"
                stroke="#4E7CFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.2017 15.9965H16.5566"
                stroke="#4E7CFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6728 11C23.6728 11 16.3022 11.0039 16.2907 11.0039C13.6408 11.0205 12 12.7961 12 15.5044V24.4956C12 27.2176 13.6533 29 16.3262 29C16.3262 29 23.6959 28.9971 23.7084 28.9971C26.3582 28.9804 28 27.2039 28 24.4956V15.5044C28 12.7824 26.3458 11 23.6728 11Z"
                stroke="#4E7CFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TotalOrders;
